import * as yup from 'yup';

const isValidDate = (value: string) => {
  const date = new Date(value);
  return !isNaN(date.getTime());
};

const isBeforeDate = (startDate: string, endDate: string) => {
  if (!startDate || !endDate) return true;
  return new Date(startDate) < new Date(endDate);
};


const isAfterFirstSemester = (startSecondSemester: string, endFirstSemester: string) => {
  if (!startSecondSemester || !endFirstSemester) return true;
  return new Date(startSecondSemester) > new Date(endFirstSemester);
};

const isAtLeastFiveMonthsApart = (startDate: string, endDate: string) => {
  if (!startDate || !endDate) return true;
  const start = new Date(startDate);
  const end = new Date(endDate);
  
  const diffInTime = end.getTime() - start.getTime();
  const diffInMonths = diffInTime / (1000 * 3600 * 24 * 30); 
  return diffInMonths >= 5; 
};

export const CreateAcademicPeriodFormValidation = yup.object().shape({
  idAcademicYear: yup
    .string()
    .required('O ID do ano acadêmico é obrigatório.'),

  startFirstSemester: yup
    .string()
    .required('A data de início do primeiro semestre é obrigatória.')
    .test('is-date', 'Data inválida', isValidDate)
    .test('is-before-end', 'O início do primeiro semestre deve ser antes do término.',
      function(value) {
        return isBeforeDate(value, this.parent.endFirstSemester);
      })
    .test('is-at-least-5-months', 'O intervalo do primeiro semestre deve ser de pelo menos 5 meses.',
      function(value) {
        return isAtLeastFiveMonthsApart(value, this.parent.endFirstSemester);
      }),

  endFirstSemester: yup
    .string()
    .required('A data de término do primeiro semestre é obrigatória.')
    .test('is-date', 'Data inválida', isValidDate)
    .test('is-at-least-5-months', 'O intervalo do primeiro semestre deve ser de pelo menos 5 meses.',
      function(value) {
        return isAtLeastFiveMonthsApart(this.parent.startFirstSemester, value);
      }),

  startSecondSemester: yup
    .string()
    .required('A data de início do segundo semestre é obrigatória.')
    .test('is-date', 'Data inválida', isValidDate)
    .test('is-before-end', 'O início do segundo semestre deve ser antes do término.',
      function(value) {
        return isBeforeDate(value, this.parent.endSecondSemester);
      })
    .test('is-after-first-semester', 'O início do segundo semestre deve ser após o término do primeiro semestre.',
      function(value) {
        return isAfterFirstSemester(value, this.parent.endFirstSemester);
      })
    .test('is-at-least-5-months', 'O intervalo do segundo semestre deve ser de pelo menos 5 meses.',
      function(value) {
        return isAtLeastFiveMonthsApart(value, this.parent.endSecondSemester);
      }),

  endSecondSemester: yup
    .string()
    .required('A data de término do segundo semestre é obrigatória.')
    .test('is-date', 'Data inválida', isValidDate)
    .test('is-after-first-semester', 'O término do segundo semestre deve ser após o término do primeiro semestre.',
      function(value) {
        return isAfterFirstSemester(value, this.parent.endFirstSemester);
      })
    .test('is-at-least-5-months', 'O intervalo do segundo semestre deve ser de pelo menos 5 meses.',
      function(value) {
        return isAtLeastFiveMonthsApart(this.parent.startSecondSemester, value);
      }),

  startAdmissionExam: yup
    .string()
    .required('A data de início dos exames de admissão é obrigatória.')
    .test('is-date', 'Data inválida', isValidDate)
    .test('is-before-end', 'O início dos exames de admissão deve ser antes do término.',
      function(value) {
        return isBeforeDate(value, this.parent.endAdmissionExam);
      }),

  endAdmissionExam: yup
    .string()
    .required('A data de término dos exames de admissão é obrigatória.')
    .test('is-date', 'Data inválida', isValidDate),

  startNormalExam: yup
    .string()
    .required('A data de início dos exames normais é obrigatória.')
    .test('is-date', 'Data inválida', isValidDate)
    .test('is-before-end', 'O início dos exames normais deve ser antes do término.',
      function(value) {
        return isBeforeDate(value, this.parent.endNormalExam);
      }),

  endNormalExam: yup
    .string()
    .required('A data de término dos exames normais é obrigatória.')
    .test('is-date', 'Data inválida', isValidDate),

  startRecurrentExam: yup
    .string()
    .required('A data de início dos exames recorrentes é obrigatória.')
    .test('is-date', 'Data inválida', isValidDate)
    .test('is-before-end', 'O início dos exames recorrentes deve ser antes do término.',
      function(value) {
        return isBeforeDate(value, this.parent.endRecurrentExam);
      }),

  endRecurrentExam: yup
    .string()
    .required('A data de término dos exames recorrentes é obrigatória.')
    .test('is-date', 'Data inválida', isValidDate),

  startEnrollment: yup
    .string()
    .required('A data de início das matrículas é obrigatória.')
    .test('is-date', 'Data inválida', isValidDate)
    .test('is-before-end', 'O início das matrículas deve ser antes do término.',
      function(value) {
        return isBeforeDate(value, this.parent.endEnrollment);
      }),

  endEnrollment: yup
    .string()
    .required('A data de término das matrículas é obrigatória.')
    .test('is-date', 'Data inválida', isValidDate),

    forceUsePeriod: yup.boolean().required('O uso forçado do período é obrigatório.'),
    startNormalExamSecondSemester: yup.string().required('A data de início do exame normal do segundo semestre é obrigatória.').test('is-date', 'Data inválida', isValidDate),
    endNormalExamSecondSemester: yup.string().required('A data de término do exame normal do segundo semestre é obrigatória.').test('is-date', 'Data inválida', isValidDate),
    startRecurrentExamSecondSemester: yup.string().required('A data de início do Exame de Recorrência do segundo semestre é obrigatória.').test('is-date', 'Data inválida', isValidDate),
    endRecurrentExamSecondSemester: yup.string().required('A data de término do Exame de Recorrência do segundo semestre é obrigatória.').test('is-date', 'Data inválida', isValidDate),
    startSubscription: yup.string().required('A data de início da inscrição é obrigatória.').test('is-date', 'Data inválida', isValidDate),
    endSubscription: yup.string().required('A data de término da inscrição é obrigatória.').test('is-date', 'Data inválida', isValidDate),
    startSubscriptionSecondSemester: yup.string().required('A data de início da inscrição é obrigatória.').test('is-date', 'Data inválida', isValidDate),
    endSubscriptionSecondSemester: yup.string().required('A data de término da inscrição é obrigatória.').test('is-date', 'Data inválida', isValidDate),
});
